export const WaTableSkeleton = () => (
    <tbody>
        {Array.from({ length: 4 }).map((_, i) => (
            <tr key={i} className="border-b border-slate-800/50">
                <td className="px-4 py-4 text-center">
                    <div className="w-4 h-4 mx-auto rounded bg-slate-700/40 animate-pulse" />
                </td>
                <td className="px-4 py-4 text-center">
                    <div className="w-6 h-4 mx-auto rounded bg-slate-700/40 animate-pulse" />
                </td>
                <td className="px-4 py-4">
                    <div className="flex items-center gap-2.5">
                        <div className="w-8 h-8 rounded-lg bg-slate-700/40 animate-pulse" />
                        <div className="w-28 h-4 rounded bg-slate-700/40 animate-pulse" />
                    </div>
                </td>
                <td className="px-4 py-4">
                    <div className="w-32 h-4 rounded bg-slate-700/40 animate-pulse" />
                </td>
                <td className="px-4 py-4 text-center">
                    <div className="w-20 h-6 mx-auto rounded-full bg-slate-700/40 animate-pulse" />
                </td>
                <td className="px-4 py-4 text-center">
                    <div className="inline-grid grid-cols-4 gap-1">
                        <div className="w-[68px] h-7 rounded-lg bg-slate-700/40 animate-pulse" />
                        <div className="w-[68px] h-7 rounded-lg bg-slate-700/40 animate-pulse" />
                        <div className="w-[68px] h-7 rounded-lg bg-slate-700/40 animate-pulse" />
                        <div className="w-[68px] h-7 rounded-lg bg-slate-700/40 animate-pulse" />
                    </div>
                </td>
            </tr>
        ))}
    </tbody>
);
